import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const createTVShow = createAsyncThunk(
  "tvShows/createTVShow",
  async (newTVShow) => {
    const response = await axios.post(`${BASE_URL}/api/tvshows`, newTVShow);
    return response.data;
  }
);

const tvShowSlice = createSlice({
  name: "tvShows",
  initialState: {
    tvShow: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearTVShow: (state) => {
      state.tvShow = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // create tv show
      .addCase(createTVShow.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createTVShow.fulfilled, (state, action) => {
        state.tvShow = action.payload; // created tv show
        state.isLoading = false;
      })
      .addCase(createTVShow.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearTVShow } = tvShowSlice.actions;

export default tvShowSlice.reducer;
